import {createContext, useCallback, useContext, useMemo} from 'react'

import {MEMBER_STATUS} from '$types/member'

import type {MemberInfoWithStatus, SuccessMemberInfo} from '$types/member'
import type {PropsWithChildren} from 'react'

interface MemberInfoContextType {
    info: MemberInfoWithStatus
    isSuccess: (info: MemberInfoWithStatus) => info is SuccessMemberInfo
}

const Context = createContext<MemberInfoContextType | undefined>(undefined)

export function MemberInfoProvider({memberInfo, children}: PropsWithChildren<{memberInfo: MemberInfoWithStatus}>) {
    // 타입 체크용으로 사용
    const isSuccess = useCallback(
        (info: MemberInfoWithStatus): info is SuccessMemberInfo => info?.status === MEMBER_STATUS.SUCCESS,
        [],
    )

    const value = useMemo(
        () => ({
            info: memberInfo,
            isSuccess,
        }),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [],
    )

    return <Context.Provider value={value}>{children}</Context.Provider>
}

export function useMemberContext() {
    const context = useContext(Context)

    if (context === undefined) {
        throw new Error('useMemberContext must be within MemberInfoProvider')
    }

    return context
}
